import { Link } from "react-router-dom";
import Container from "./Container";

const Works = () => {
  return (
    <div className="bg-2 py-20" id="works">
      <Container>
        <h2 className="mb-8 text-center text-3xl font-bold text-centertracking-wider">
          WORKS
        </h2>
        <section>
          <div className="mx-auto grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3">
            <Link to="/work1">
              <img className="object-contain" src="./be-pretty.png" alt="" />
              <p className="font-bold mt-1">Be Pretty | E-commerce website</p>
              <p className="works-info">Design / Coding(Responsive)</p>
            </Link>
            <Link to="/work2">
              <img
                className="object-contain"
                src="./movie-watchlist.png"
                alt=""
              />
              <p className="font-bold mt-1">Movie Watchlist</p>
              <p className="works-info">Coding</p>
            </Link>

            <Link to="/work3">
              <img
                className="object-contain"
                src="./color-generator.png"
                alt=""
              />
              <p className="font-bold mt-1">Color Picker</p>
              <p className="works-info">Coding</p>
            </Link>
            <Link to="/work4">
              <img
                className="object-contain"
                src="./unit-conversion.png"
                alt=""
              />
              <p className="font-bold mt-1">Metric/Imperial Unit Conversion</p>
              <p className="works-info">Coding</p>
            </Link>
          </div>
        </section>
      </Container>
    </div>
  );
};

export default Works;
